module.exports = __webpack_public_path__ + "static/ilmater-symbol-SCAG-e27b98fb06eabdf80fd6bc5d35439dc6.png";